<template>
  <span>
    <a
      v-on-clickaway="hideDropdown"
      class="nav-link dropdown-toggle"
      href="javascript:void(0)"
      :aria-expanded="expanded"
      :class="{ active: isTabActive }"
      @click="toggleDropdown"
    >
      {{ tab.title }}
    </a>

    <div class="dropdown-menu" :class="{ show: expanded }">
      <check-permission
        v-for="(dropdownItem, index) in tab.children"
        :key="index"
        :entity-id="dropdownItem.entityId || entityId"
        :entity-type="dropdownItem.entityType || entityType"
        :permissions="dropdownItem.permissions"
        :join-type="dropdownItem.joinType"
      >
        <tab-link class="dropdown-item" :tab="dropdownItem" />
      </check-permission>
    </div>
  </span>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

import { tabsMixin } from '@/mixins/tabs';
import TabLink from './TabLink';

// @vuese
// Dropdown zakładki
// @group Components
export default {
  components: { TabLink },
  mixins: [clickaway, tabsMixin],
  props: {
    // Zakładka z menu
    tab: {
      type: Object,
      required: true
    },
    // Encja
    entityType: {
      type: String,
      required: false
    },
    // Id encji
    entityId: {
      type: String,
      required: false
    }
  },
  data() {
    return { expanded: false };
  },
  computed: {
    isTabActive() {
      return this.tab.children.some(childrenTab => this.isActive(childrenTab));
    }
  },
  methods: {
    // @vuese
    // Rozsuwa menu
    toggleDropdown() {
      this.expanded = !this.expanded;
    },
    // @vuese
    // Chowa menu
    hideDropdown() {
      this.expanded = false;
    }
  }
};
</script>

<style>
.dropdown-toggle {
  cursor: pointer;
}
</style>
